"use strict";
exports.__esModule = true;
exports.AlertType = void 0;
var AlertType;
(function (AlertType) {
    AlertType["AccountSetup"] = "accountSetup";
    AlertType["Conductor"] = "conductor";
    AlertType["Conversion"] = "conversion";
    AlertType["Disbursement"] = "disbursement";
    AlertType["IntegrationsGateway"] = "Integrations Gateway";
    AlertType["Investments"] = "investments";
    AlertType["MoneyIn"] = "moneyIn";
    AlertType["MoneyOut"] = "moneyOut";
    AlertType["Monitoring"] = "monitoring";
    AlertType["Rollovers"] = "rollovers";
    AlertType["Trading"] = "trading";
})(AlertType = exports.AlertType || (exports.AlertType = {}));
